module.exports = "<app-navbar></app-navbar>\n<router-outlet></router-outlet>\n<!-- <app-dshboard>\n</app-dshboard>\n<app-auth></app-auth> -->"